<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="endpoint-protections-wrapper">
  <app-device-config
    [selectedOrgId]="selectedOrgId$ | async">
  </app-device-config>
</div>
